// extracted by mini-css-extract-plugin
export var header = "_sj-1";
export var maskBottom = "_sj-6";
export var maskMiddle = "_sj-7";
export var maskTop = "_sj-5";
export var root = "_sj-0";
export var scrollDownButton = "_sj-3";
export var scrollDownButtonHidden = "_sj-4";
export var viewport = "_sj-2";